import { useEffect, useState } from 'react'
import { Fab, Typography, Zoom } from '@mui/material'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { useIsMobile } from '@/hooks/Responsive'

export function ScrollTopButton() {
  const { isMobile } = useIsMobile()
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setOpen(window.scrollY > 240)
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const goTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <Zoom in={open}>
      <Fab
        onClick={goTop}
        elevation={0}
        sx={{
          position: 'fixed',
          bottom: '40px',
          right: isMobile ? '24px' : '50px',
          width: isMobile ? '56px' : '64px',
          height: isMobile ? '56px' : '64px',
          flexDirection: 'column',
          bgcolor: 'rgba(255,255,255,0.8)',
          color: 'text.primary',
          zIndex: 1300,
          border: '1px solid',
          borderColor: 'divider',
          transition: 'all 0.3s ease !important',
          boxShadow: 'none !important',
          '&:hover': {
            bgcolor: 'primary.main',
            borderColor: 'primary.main',
            color: 'text.contrastText',
          },
        }}
      >
        <KeyboardArrowUpIcon sx={{ fontSize: '20px' }} />
        <Typography variant="body2">TOP</Typography>
      </Fab>
    </Zoom>
  )
}
